module.exports = __webpack_public_path__ + "img/logo.85b33d51.png";